import { Container } from "react-bootstrap";
import ServicesAccordionTable from "../components/service-accordion-table/ServicesAccordionTable";
import ServicesInfo2 from "../components/ServicesInfo2";
import texts from "../texts";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { getAlertsRequest } from "../redux/actions";
import { AppState } from "../redux/types";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { useHreflang } from "../i18n/hooks/useHreflang";
import { getLocaleFromPath, localePath } from "../i18n/config";
import { metadataTranslations } from "../i18n/metadata";
import Button from "../components/button/Button";
import SeniorTabletBanner from "../components/senior-tablet-banner/SeniorTabletBanner";

const Services = () => {
    const hreflang = useHreflang("palvelu");
    const locale = getLocaleFromPath();
    const meta = metadataTranslations.services[locale] || metadataTranslations.services.fi;
    const dispatch = useDispatch();

    const currentDate = Date.now();

    useEffect(() => {
        dispatch(getAlertsRequest());
        return () => {};
    }, [dispatch]);

    const resources = useSelector((state: AppState) => state.alerts);
    const { list } = resources;

    const [play, setPlay] = useState(0);

    const tabletCover = locale === "en" ? "/assets/images/en/tablet-cover.jpg"
        : locale === "sv" ? "/assets/images/sv/tablet-cover.jpg"
        : "/assets/images/banners/paras-tabletti-senorille.webp";

    const youtubeId = locale === "sv" ? "ccuOfp_YV9A"
        : locale === "en" ? "dLWx9rBQdwI"
        : "U3AGXnauUQg";

    return (
        <>
            <Helmet>
                <title>{meta.title}</title>
                <meta name="description" content={meta.description} />
                <link rel="alternate" hrefLang="fi" href={hreflang.fi} />
                <link rel="alternate" hrefLang="en" href={hreflang.en} />
                <link rel="alternate" hrefLang="sv" href={hreflang.sv} />
                <link rel="alternate" hrefLang="x-default" href={hreflang.fi} />
            </Helmet>
            <Container
                fluid
                style={{
                    height: `calc(100vh - ${
                        56 +
                        56 *
                            list?.filter((el) => {
                                // @ts-ignore
                                return (!el.start || new Date(el.start) <= currentDate) && (!el.end || new Date(el.end) >= currentDate);
                            })?.length -
                        1
                    }px)`,
                    width: "100vw",
                    backgroundRepeat: "no-repeat",
                    backgroundImage: `url('${tabletCover}')`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    position: "relative",
                    minHeight: 640,
                }}
                aria-label="Henkilö käyttää tablettia, jonka näytöllä näkyy erilaisia sovelluksia."
                className="img-fluid contact-pic services-banner"
            >
                <div className="global-banner-text-container">
                    <h1 className="global-banner-title global-white">{texts[9].text1}</h1>
                    <p className="global-banner-text global-white">
                        {texts[9].text2}
                        <br />
                        {texts[9].text3}
                    </p>
                    <Link to={localePath("osta", "senioritabletti")} style={{ marginTop: "auto" }}>
                        <Button secondary emphasized>
                            Osta senioritabletti
                        </Button>
                    </Link>
                </div>
        </Container>
        <SeniorTabletBanner/>
            <Container fluid className="my-3 services-container services-container-80" style={{ minWidth: "min(900px, 100%)" }}>
                <ServicesInfo2 />
        </Container>
        <div id="palveluvertailu">
            <h1 className="services-header" style={{ marginBottom: 0, fontWeight: 600 }}>
              Valitse seniorille paras palvelu
            </h1>

        </div>
        <ServicesAccordionTable />

            <Container fluid className="my-3 services-container service-table-container" id="vertailutaulukko">

                <div className="services-button-container">
            <Button hidden={true}  onClick={() => setPlay(1)}>Katso video</Button>
                    <div className="global-video-wrapper">
                        {youtubeId ? (
                            <iframe
                                src={`https://www.youtube.com/embed/${youtubeId}?autoplay=${play}`}
                                allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; autoplay"
                                allowFullScreen
                                title="Digihappy Senioritabletit"
                                style={{
                                    margin: "0 auto",
                                    width: "100%",
                                    height: "100%",
                                    border: "none",
                                    aspectRatio: 16 / 9,
                                }}
                            />
                        ) : (
                            <div style={{ background: "#e0e0e0", width: "100%", aspectRatio: "16/9", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                <p style={{ fontSize: "1.2rem", color: "#666" }}>Video coming soon</p>
                            </div>
                        )}
            </div>
            <p className="global-text text-normal  global-text-dark">
              <strong>*</strong>Saatte ensimmäisen kuukauden Digihappy-palvelua koskevaa it- tukea maksutta ilman rajoituksia. Tämän jälkeen yksilöllinen it-tuki on maksutonta 45 minuuttia /kk Lisätuen kustannus on 10 €/10 minuuttia, minimiveloitus on 10 €/puhelu. Jos kyseessä on palvelun tai laitteen meihin liittyvä toimintahäiriö, sen ratkaiseminen on aina teille maksutonta.

              <br></br><strong>**</strong> Tablettien sisältövalikoima voi päivittyä ja muuttua, jotta voimme aina tarjota parhaan käyttäjäkokemuksen asiakkaalle.
            <br></br>  Seniorin tabletissa on valmiina maksuton äänikirjasovellus, jonka tuottaa Celia. Palvelu on henkilöille, joilla on lukemisvaikeus, esimerkiksi ikäihmisellä heikentynyt näkö, lihaskunto, toimintakyky tai muisti. Digihappy neuvoo, miten saat palvelun käyttöön ja omat tunnukset kirjastosta.
            </p>
                </div>
            </Container>
        </>
    );
};

export default Services;
